// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 6: МИССИИ ПАВЛА
// ============================================================================
// Уровни 66-78 (13 уровней, 39 вопросов)

export const chapter6Translations = {
  name: "Миссии Павла",
  description: "До краев земли...",
  
  spiritualWisdom: {
    principle: "Евангелие для всех народов и должно быть возвещено всему миру",
    scripture: "Идите, научите все народы (Матфея 28:19)",
    application: "Каждый христианин призван быть свидетелем Христа там, где Бог его поместил"
  },
  
  levels: {
    66: {
      name: "Первое Миссионерское Путешествие",
      challenge: "Отделите Мне Варнаву и Савла на дело, к которому Я призвал их...",
      easy: {
        question: "Кто сопровождал Павла в его первом путешествии?",
        options: ["Петр", "Варнава", "Сила", "Тимофей"],
        hint: "'Сын утешения'",
        funFact: "👥 Варнава принял Павла после его обращения - провиденциальное партнерство!"
      },
      medium: {
        question: "Из какого города они отправились в миссию?",
        options: [
          "Иерусалим",
          "Антиохия Сирийская",
          "Тарс",
          "Дамаск"
        ],
        hint: "Первая смешанная церковь из иудеев и язычников",
        funFact: "🚢 Антиохия: порт отправления евангелизации западного мира!"
      },
      hard: {
        question: "Что открывает это первое путешествие о миссионерской стратегии?",
        options: [
          "Нужно оставаться в своем регионе",
          "Евангелие преодолевает все культурные границы",
          "Только иудеи могут быть спасены",
          "Миссия факультативна"
        ],
        hint: "Речь идет об универсальности послания",
        funFact: "🌊 Пересечь Средиземное море = сделать шаг к мировой евангелизации!"
      }
    },
    
    67: {
      name: "На Кипре с Елимой",
      challenge: "О, исполненный всякого коварства и всякого злодейства, сын диавола...",
      easy: {
        question: "Какой волхв противостал Павлу на Кипре?",
        options: ["Симон", "Елима", "Аполлос", "Александр"],
        hint: "Лжепророк, который хотел отвратить проконсула",
        funFact: "🪄 Первое прямое противостояние между Евангелием и магией!"
      },
      medium: {
        question: "Что сделал Павел с Елимой в наказание?",
        options: [
          "Изгнал его",
          "Ослепил его временно",
          "Проигнорировал его",
          "Спорил с ним"
        ],
        hint: "Временная слепота, чтобы открыть ему духовные глаза",
        funFact: "👁️ Божественная ирония: тот, кто ослеплял души, становится временно слепым!"
      },
      hard: {
        question: "Как этот эпизод иллюстрирует силу Евангелия?",
        options: [
          "Насилие необходимо",
          "Божественная истина торжествует над ложью",
          "Нужно бороться со всеми магами",
          "Павел был мстительным"
        ],
        hint: "Речь идет о божественном авторитете перед обманом",
        funFact: "⚡ Проконсул верит, видя божественную силу - эффективная демонстрация!"
      }
    },

    68: {
      name: "В Антиохии Писидийской",
      challenge: "Вам первым надлежало быть проповедану слову Божию...",
      easy: {
        question: "Где проповедовал Павел, прибывая в город?",
        options: [
          "На общественной площади",
          "Сначала в синагоге",
          "У богатых",
          "В языческих храмах"
        ],
        hint: "Он всегда начинал со своего народа",
        funFact: "🕍 Миссионерская стратегия: сначала к иудеям, потом к язычникам!"
      },
      medium: {
        question: "Как иудеи отреагировали на послание Павла?",
        options: [
          "Все приняли его",
          "Разделились: одни уверовали, другие противостали",
          "Остались равнодушными",
          "Немедленно изгнали его"
        ],
        hint: "Классическое разделение перед Евангелием",
        funFact: "⚖️ Евангелие всегда разделяет: принятие или отвержение, не безразличие!"
      },
      hard: {
        question: "Почему Павел обращается к язычникам?",
        options: [
          "Он предпочитал язычников",
          "Отвержение иудеев открывает дверь народам",
          "Это было легче",
          "Он оставлял свою миссию"
        ],
        hint: "Речь идет о пророческом исполнении",
        funFact: "🚪 'Свет для язычников' - пророчество Исаии, исполненное Павлом!"
      }
    },

    69: {
      name: "Исцеление в Листре",
      challenge: "Боги в образе человеческом сошли к нам!",
      easy: {
        question: "Кого исцелил Павел в Листре?",
        options: [
          "Слепого",
          "Хромого от рождения",
          "Глухонемого",
          "Прокаженного"
        ],
        hint: "Кто-то, кто никогда не ходил",
        funFact: "🦵 Зрелищное чудо: 'Стань прямо на ноги твои!' - исцеляющая вера!"
      },
      medium: {
        question: "За кого толпа приняла Павла и Варнаву?",
        options: [
          "Царей",
          "Богов (Юпитера и Меркурия)",
          "Волхвов",
          "Пророков"
        ],
        hint: "Божества греческого пантеона",
        funFact: "⚡ Варнава = Юпитер (внушительный), Павел = Меркурий (оратор) - культурное недоразумение!"
      },
      hard: {
        question: "Как отреагировал Павел на это идолопоклонническое поклонение?",
        options: [
          "Принимает почести",
          "Раздирает одежды и проповедует истинного Бога",
          "Молчит из вежливости",
          "Использует ситуацию"
        ],
        hint: "Полное отвержение идолопоклонства",
        funFact: "👔 Раздирание одежд = иудейский ужас перед идолопоклонством - полная честность!"
      }
    },

    70: {
      name: "Побиение Камнями и Воскрешение",
      challenge: "Когда же ученики собрались около него, он встал и пошел в город...",
      easy: {
        question: "Что сделали жители Листры с Павлом?",
        options: [
          "Заключили в тюрьму",
          "Побили камнями",
          "Изгнали",
          "Распяли"
        ],
        hint: "Традиционное иудейское наказание",
        funFact: "🪨 От 'бога' к 'мертвому' за один день - непостоянство человеческой толпы!"
      },
      medium: {
        question: "Что сделал Павел после побиения камнями?",
        options: [
          "Бежал из города",
          "Спрятался",
          "Встал и вернулся в город",
          "Пошел в больницу"
        ],
        hint: "Сверхъестественная смелость после предполагаемой смерти",
        funFact: "💪 Чудесное воскрешение или божественное исцеление - невероятная смелость!"
      },
      hard: {
        question: "Что раскрывает это гонение о цене свидетельства?",
        options: [
          "Нужно избегать конфликтов",
          "Свидетельствовать за Христа может стоить жизни",
          "Павел был неосторожен",
          "Гонение бесполезно"
        ],
        hint: "Речь идет о цене подлинного свидетельства",
        funFact: "✝️ 'Многими скорбями надлежит нам войти' - реализм Павла!"
      }
    },

    71: {
      name: "Иерусалимский Собор",
      challenge: "Если не обрежетесь, не можете спастись...",
      easy: {
        question: "Какие важные дебаты состоялись на Иерусалимском соборе?",
        options: [
          "Крещение",
          "Обрезание обращенных язычников",
          "День субботний",
          "Приношения"
        ],
        hint: "Нужно ли было стать иудеем, чтобы быть христианином?",
        funFact: "✂️ Первый серьезный кризис: христианство или иудео-христианство?"
      },
      medium: {
        question: "Каково было окончательное решение собора?",
        options: [
          "Обязательное обрезание",
          "Свобода для язычников с некоторыми рекомендациями",
          "Полное отделение от иудеев",
          "Отсрочка решения"
        ],
        hint: "Открытость для язычников без серьезных ограничений",
        funFact: "🆓 Историческая революция: Евангелие свободно от закона Моисея!"
      },
      hard: {
        question: "Какое значение имеет этот собор для вселенской Церкви?",
        options: [
          "Незначительное событие",
          "Устанавливает универсальность спасения только верой",
          "Разделяет Церковь",
          "Усиливает законничество"
        ],
        hint: "Речь идет об основании вселенской Церкви",
        funFact: "🌍 Без этого решения христианство осталось бы иудейской сектой!"
      }
    },

    72: {
      name: "Второе Путешествие: Тимофей",
      challenge: "Павел хотел взять его с собою и обрезал его ради Иудеев...",
      easy: {
        question: "Кто присоединился к Павлу как молодой соработник?",
        options: ["Марк", "Лука", "Тимофей", "Тит"],
        hint: "'Возлюбленный сын' Павла",
        funFact: "👦 Тимофей: молодой вундеркинд, ставший правой рукой Павла - успешное наставничество!"
      },
      medium: {
        question: "Почему Павел обрезал Тимофея, несмотря на обретенную свободу?",
        options: [
          "По юридической обязанности",
          "По миссионерской стратегии среди иудеев",
          "По традиции",
          "По ошибке"
        ],
        hint: "Практическая мудрость, чтобы избежать препятствий",
        funFact: "🎯 Свобода с мудростью: 'Для всех я сделался всем, чтобы спасти по крайней мере некоторых'!"
      },
      hard: {
        question: "Как эта позиция иллюстрирует миссионерскую гибкость?",
        options: [
          "Павел был непостоянен",
          "Он адаптировал свой метод, не компрометируя Евангелие",
          "Он уступал давлению",
          "Он был лицемером"
        ],
        hint: "Речь идет о контекстуальной мудрости",
        funFact: "⚖️ Твердые принципы, гибкие методы - искусство эффективного свидетельства!"
      }
    },

    73: {
      name: "Видение Македонянина",
      challenge: "Приди в Македонию и помоги нам!",
      easy: {
        question: "Что увидел Павел в ночном видении?",
        options: [
          "Ангела",
          "Македонянина, призывающего его",
          "Иисуса, говорящего с ним",
          "Великий свет"
        ],
        hint: "Призыв о помощи из Европы",
        funFact: "🌉 Решающее видение: Евангелие пересекает в Европу - исторический поворот!"
      },
      medium: {
        question: "Какой был первый евангелизированный европейский город?",
        options: [
          "Афины",
          "Коринф",
          "Филиппы",
          "Фессалоники"
        ],
        hint: "Римская колония в Македонии",
        funFact: "🏛️ Филиппы: первая европейская церковь - континент навсегда преобразован!"
      },
      hard: {
        question: "Что символизирует это видение для истории христианства?",
        options: [
          "Обычный сон",
          "Провиденциальная экспансия на Запад",
          "Галлюцинация",
          "Изменение плана"
        ],
        hint: "Речь идет о Провидении, направляющем историю",
        funFact: "🗺️ Без этого видения Европа могла остаться языческой - божественный план!"
      }
    },

    74: {
      name: "Лидия, Первая Европейская Обращенная",
      challenge: "Господь отверз сердце Лидии внимать тому...",
      easy: {
        question: "Каким было ремесло Лидии?",
        options: [
          "Пекарь",
          "Торговка багряницей",
          "Ткачиха",
          "Гончар"
        ],
        hint: "Роскошная торговля той эпохи",
        funFact: "🟣 Пурпур = королевский цвет, очень дорогой - Лидия была процветающей!"
      },
      medium: {
        question: "Где Павел встретил Лидию?",
        options: [
          "На рынке",
          "У реки во время молитвы",
          "В ее доме",
          "В синагоге"
        ],
        hint: "Место молитвы под открытым небом",
        funFact: "🏞️ В Филиппах не было синагоги - молитва у воды по традиции!"
      },
      hard: {
        question: "Что раскрывает обращение Лидии о божественной работе?",
        options: [
          "Она была предрасположена",
          "Бог открывает сердца, готовые принять Его Слово",
          "Это было совпадение",
          "Павел был убедительным"
        ],
        hint: "Речь идет о божественном действии в обращении",
        funFact: "💝 'Господь отверз сердце ее' - Бог готовит и открывает души!"
      }
    },

    75: {
      name: "Тюрьма в Филиппах",
      challenge: "Около полуночи Павел и Сила молились и воспевали Бога...",
      easy: {
        question: "Почему Павел и Сила были заключены в тюрьму?",
        options: [
          "Кража",
          "Нарушение общественного порядка изгнанием беса",
          "Богохульство",
          "Мятеж"
        ],
        hint: "Исцеление рабыни-прорицательницы",
        funFact: "💸 Освободить душу дорого стоит ее эксплуататорам - экономическое преследование!"
      },
      medium: {
        question: "Что делали Павел и Сила в тюрьме?",
        options: [
          "Жаловались",
          "Молились и пели",
          "Готовили свою защиту",
          "Спали"
        ],
        hint: "Хвала несмотря на цепи",
        funFact: "🎵 Песни хвалы в полночь в тюрьме - непоколебимая вера, которая впечатляет!"
      },
      hard: {
        question: "Как их позиция преобразовала ситуацию?",
        options: [
          "Не имела эффекта",
          "Обратила тюремщика после землетрясения",
          "Раздражила стражей",
          "Свела их с ума"
        ],
        hint: "Мощное свидетельство примером",
        funFact: "🌍 Землетрясение + свидетельство = обращение тюремщика и его семьи!"
      }
    },

    76: {
      name: "В Афинах: Ареопаг",
      challenge: "Что вы, не зная, чтите, то я проповедую вам...",
      easy: {
        question: "На какой жертвенник сослался Павел в Афинах?",
        options: [
          "На бога Зевса",
          "На неведомого бога",
          "На Аполлона",
          "На Афину"
        ],
        hint: "Таинственная надпись, послужившая отправной точкой",
        funFact: "🏛️ 'Неведомому богу' - гениальная точка соприкосновения с греческой философией!"
      },
      medium: {
        question: "Перед кем проповедовал Павел в Афинах?",
        options: [
          "Обычной толпой",
          "Философами эпикурейцами и стоиками в Ареопаге",
          "Жрецами храмов",
          "Римским императором"
        ],
        hint: "Греческая интеллектуальная элита",
        funFact: "🧠 Ареопаг = древний Гарвард - Павел перед величайшими мыслителями!"
      },
      hard: {
        question: "Какова была реакция афинян на воскресение?",
        options: [
          "Единодушное принятие",
          "Разделение: насмешка одних, интерес других",
          "Общий гнев",
          "Полное безразличие"
        ],
        hint: "Типичная реакция интеллектуалов на эту тайну",
        funFact: "🤔 Воскресение = камень преткновения для гордого человеческого разума!"
      }
    },

    77: {
      name: "Коринф: Павел Делатель Палаток",
      challenge: "Жил у них и работал, ибо ремеслом были делатели палаток...",
      easy: {
        question: "Какое ремесло практиковал Павел, чтобы зарабатывать на жизнь?",
        options: [
          "Рыбак",
          "Делатель палаток",
          "Книжник",
          "Купец"
        ],
        hint: "Ручное ремесло, которому он научился",
        funFact: "⛺ Павел: апостол-ремесленник - достоинство ручного труда у христиан!"
      },
      medium: {
        question: "У кого остановился Павел в Коринфе?",
        options: [
          "В гостинице",
          "У Акилы и Прискиллы",
          "У правителя",
          "В синагоге"
        ],
        hint: "Пара делателей палаток, как и он",
        funFact: "👫 Акила и Прискилла: образцовая миссионерская пара - христианское гостеприимство!"
      },
      hard: {
        question: "Почему Павел работал своими руками?",
        options: [
          "Только по финансовой необходимости",
          "Чтобы не быть в тягость и подтвердить свое свидетельство",
          "По семейной традиции",
          "Потому что любил это ремесло"
        ],
        hint: "Речь идет о независимости и достоверности",
        funFact: "💼 Финансовая автономия = свобода слова - Павел ни от кого не зависел!"
      }
    },

    78: {
      name: "Мятеж в Ефесе",
      challenge: "Велика Артемида Ефесская!",
      easy: {
        question: "Кто спровоцировал мятеж против Павла в Ефесе?",
        options: [
          "Римские власти",
          "Димитрий серебряник и ремесленники",
          "Философы",
          "Иудейские священники"
        ],
        hint: "Те, кто изготавливал храмы Артемиды",
        funFact: "🏛️ Первая забастовка в истории: Евангелие угрожает идолопоклоннической экономике!"
      },
      medium: {
        question: "Сколько времени Павел учил в Ефесе?",
        options: [
          "6 месяцев",
          "1 год",
          "2 года",
          "3 года"
        ],
        hint: "Его самое долгое миссионерское пребывание",
        funFact: "📅 3 года интенсивного обучения - Ефес стал важным миссионерским центром!"
      },
      hard: {
        question: "Что раскрывает этот мятеж о социальном воздействии Евангелия?",
        options: [
          "Евангелие ничего не меняет",
          "Оно преобразует экономические и социальные структуры",
          "Касается только религии",
          "Избегает конфликтов"
        ],
        hint: "Речь идет о глубокой социальной трансформации",
        funFact: "💰 Когда Евангелие продвигается, идолы теряют свой рынок - экономический эффект!"
      }
    }
  }
};

export default chapter6Translations;
